// extracted by mini-css-extract-plugin
export var root = "header-module--root--KGdif";
export var wrapper = "header-module--wrapper--uoQUP";
export var branding = "header-module--branding--i2gkj";
export var toggleNavButton = "header-module--toggleNavButton--r2rxY";
export var nav = "header-module--nav--e8OJ3";
export var showNav = "header-module--showNav--Q9H09";